import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserTransactionHistory = {
  userTransactionHistory: { data: null, loading: false, error: null },
};

export const userTransactionHistory = createAsyncThunk('user/userTransactionHistory', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/transaction/history`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserTransactionHistory = {
  [userTransactionHistory.pending]: (state) => {
    state.userTransactionHistory.loading = true;
  },
  [userTransactionHistory.fulfilled]: (state, action) => {
    state.userTransactionHistory.loading = false;
    state.userTransactionHistory.data = action.payload;
    state.userTransactionHistory.error = null;
  },
  [userTransactionHistory.rejected]: (state, action) => {
    state.userTransactionHistory.loading = false;
    state.userTransactionHistory.error = action.payload;
  },
};
